// #region Imports
import React, { useEffect, useRef, useCallback } from 'react';
import './MovimentosModal.scss';
import { formatCurrency } from '../../../../shared/helpers';
// #endregion

export default function MovimentosModal({ open = false, caixa = null, movimentos = [], onClose = () => {} }) {
  // #region Estado refs
  const overlayRef = useRef(null);
  // #endregion

  // #region Efeitos
  const onKeyDown = useCallback(e => { if (e.key === 'Escape') onClose(); }, [onClose]);
  useEffect(() => {
    if (!open) return;
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [open, onKeyDown]);
  // #endregion

  // #region Early return
  if (!open || !caixa) return null;
  // #endregion

  // #region Handlers
  function handleOverlay(e) {
    if (e.target === overlayRef.current) onClose();
  }
  // #endregion

  // #region Derivados
  const saldoMov = (caixa.total_entradas || 0) - (caixa.total_saidas || 0);
  // #endregion

  // #region Render
  return (
    <div className="crud-overlay mov-overlay" ref={overlayRef} onMouseDown={handleOverlay} role="dialog" aria-modal="true">
      <div className="crud-modal mov-modal" role="document">
        <div className="mov-header">
          <h3>Movimentos do Caixa - {caixa.data_referencia}</h3>
          <button type="button" className="close-btn" onClick={onClose} aria-label="Fechar">×</button>
        </div>
        <div className="mov-resumo">
          <div className="resumo-grid">
            <div className="resumo-item"><span className="r-label">Valor Inicial</span><span className="r-value r-muted">{formatCurrency(caixa.valor_inicial)}</span></div>
            <div className="resumo-item"><span className="r-label">Valor Estimado</span><span className="r-value r-info">{formatCurrency(caixa.valor_estimado)}</span></div>
            <div className="resumo-item"><span className="r-label">Valor Real</span><span className="r-value">{caixa.valor_real != null ? formatCurrency(caixa.valor_real) : '-'}</span></div>
            <div className="resumo-item"><span className="r-label">Status</span><span className="r-tag status">{caixa.status}</span></div>
            <div className="resumo-item"><span className="r-label">Total Entradas</span><span className="r-value r-success">{formatCurrency(caixa.total_entradas)}</span></div>
            <div className="resumo-item"><span className="r-label">Total Saídas</span><span className="r-value r-danger">{formatCurrency(caixa.total_saidas)}</span></div>
            <div className="resumo-item"><span className="r-label">Saldo Movimentos</span><span className="r-value r-success">{formatCurrency(saldoMov)}</span></div>
          </div>
        </div>
        <div className="mov-table-wrapper" role="region" aria-label="Lista de movimentos">
          <table className="mov-table">
            <thead>
              <tr>
                <th>Data/Hora</th>
                <th>Tipo</th>
                <th>Valor</th>
                <th>Método</th>
                <th>Venda</th>
                <th>Descrição</th>
              </tr>
            </thead>
            <tbody>
              {movimentos.length === 0 && <tr><td colSpan="6" className="empty">Nenhum movimento.</td></tr>}
              {movimentos.map(m => {
                const entrada = m.tipo === 'ENTRADA';
                return (
                  <tr key={m.id}>
                    <td>{m.data_hora?.replace('T', ' ').substring(0, 16)}</td>
                    <td><span className={`tag ${entrada ? 'tag-success-outline' : 'tag-danger-outline'}`}>{entrada ? 'Entrada' : 'Saída'}</span></td>
                    <td className={entrada ? 'v-ent' : 'v-sai'}>{(entrada ? '+' : '-') + formatCurrency(m.valor)}</td>
                    <td><span className="metodo">{m.metodo_pagamento || '-'}</span></td>
                    <td>{m.venda_id ? `#${m.venda_id}` : '-'}</td>
                    <td>{m.descricao || '-'}</td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
        <div className="mov-actions">
          <button type="button" onClick={onClose} className="btn-primary">Fechar</button>
        </div>
      </div>
    </div>
  );
  // #endregion
}
